"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenErx = void 0;
require("antd/lib/modal/style");
var _modal = _interopRequireDefault(require("antd/lib/modal"));
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _utils = require("../utils");
var _ = require("./");
var _components = require("../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var OpenErx = function OpenErx(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Create Prescription' : _ref$title,
    className = _ref.className,
    patientId = _ref.patientId,
    disabled = _ref.disabled,
    _ref$hideButtonWhenDi = _ref.hideButtonWhenDisabled,
    hideButtonWhenDisabled = _ref$hideButtonWhenDi === void 0 ? false : _ref$hideButtonWhenDi,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? _lodash.noop : _ref$onClose,
    _ref$withMedications = _ref.withMedications,
    withMedications = _ref$withMedications === void 0 ? false : _ref$withMedications,
    _ref$medicationsQuery = _ref.medicationsQuery,
    medicationsQuery = _ref$medicationsQuery === void 0 ? '' : _ref$medicationsQuery,
    confirmPrompt = _ref.confirmPrompt;
  var modal = (0, _utils.useModalState)();
  var confirmModal = (0, _utils.useModalState)();
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    doseSpotUrl = _useState2[0],
    setDoseSpotUrl = _useState2[1];
  var _useFetch = (0, _utils.useFetch)("".concat((0, _utils.getPatientPrescriptionsUrl)(patientId)).concat(medicationsQuery), [], withMedications),
    medications = _useFetch.data,
    loading = _useFetch.loading,
    refetchMedications = _useFetch.refetch;
  var _useFetchPrescribers = (0, _utils.useFetchPrescribers)({
      medications: medications
    }),
    prescribers = _useFetchPrescribers.prescribers;
  var handleShowConfirmPrompt = function handleShowConfirmPrompt() {
    confirmModal.show();
  };
  var handleClickPrescribe = function handleClickPrescribe() {
    if (disabled) {
      return;
    }
    if (confirmPrompt) {
      handleShowConfirmPrompt();
      return;
    }
    handleShowIframe();
  };
  var handleShowIframe = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$api$get, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              confirmModal.hide();
              if (doseSpotUrl) {
                _context.next = 7;
                break;
              }
              _context.next = 4;
              return _utils.api.get((0, _utils.getMedicationsProviderUrl)(patientId));
            case 4:
              _yield$api$get = _context.sent;
              data = _yield$api$get.data;
              setDoseSpotUrl(data.url);
            case 7:
              modal.show();
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleShowIframe() {
      return _ref2.apply(this, arguments);
    };
  }();
  var hideButton = disabled && hideButtonWhenDisabled;
  if (hideButton && !withMedications) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hideButton && /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    icon: "add-heavy-16",
    iconPosition: "left",
    disabled: disabled,
    className: className,
    onClick: handleClickPrescribe
  }, title), withMedications && /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loading
  }, /*#__PURE__*/_react.default.createElement(_.MedicationList, {
    medications: medications,
    prescribers: prescribers,
    bordered: false
  })), /*#__PURE__*/_react.default.createElement(_modal.default, {
    width: "90vw",
    bodyStyle: {
      height: '85vh',
      padding: 0
    },
    centered: true,
    visible: modal.visible,
    title: "Create New Prescription",
    destroyOnClose: true,
    closable: true,
    maskClosable: false,
    footer: null,
    onCancel: modal.hide,
    afterClose: function afterClose() {
      if (withMedications) {
        refetchMedications();
      }
      onClose();
    }
  }, doseSpotUrl ? /*#__PURE__*/_react.default.createElement("iframe", {
    title: "eRx",
    src: doseSpotUrl,
    frameBorder: "0",
    width: "100%",
    height: "100%"
  }) : /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: true
  })), /*#__PURE__*/_react.default.createElement(_components.Modal, {
    visible: confirmModal.visible,
    onClose: confirmModal.hide
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-subtitle-lg-regular mt-[48px] mx-[20px] text-grey-75"
  }, /*#__PURE__*/_react.default.createElement("p", null, confirmPrompt), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between mt-[32px] mb-[24px]"
  }, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    size: "large",
    onClick: confirmModal.hide
  }, "Nevermind"), /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    size: "large",
    onClick: handleShowIframe
  }, "Yes, prescribe")))));
};
exports.OpenErx = OpenErx;